export default __webpack_public_path__ + "static/media/talking-is-hard.61cf903f.jpg";